import { Loader } from 'react-feather';

export const Loading = () => {
  return (
    <div className="w-screen h-screen flex justify-center items-center">
      <Loader className="animate-spin" />
    </div>
  );
};
